import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import FermentationServices from "../services/fermentationServices";

const defaultFermentationState = {
  fermentationLoading: false,
  fermentationData: null,
  fermentationError: null,
};

const defaultGetFermentationState = {
  fermentationGetLoading: false,
  fermentationGetData: null,
  fermentationError: null,
};

const defaultGetFermentationDetailsByIdState = {
  fermentationGetLoading: false,
  fermentationGetData: null,
  fermentationGetError: null,
};

const defaultUpdateFermentationState = {
  fermentationUpdateLoading: false,
  fermentationUpdateData: null,
  fermentationUpdateError: null,
};

const defaultChemistryLogsState = {
  chemistryLogsLoading: false,
  chemistryLogsData: null,
  chemistryLogsError: null,
};

const defaultGetChemistryLogsState = {
  chemistryLogsGetLoading: false,
  chemistryLogsGetData: null,
  chemistryLogsGetError: null,
};

const defaultUpdateChemistryLogsState = {
  chemistryLogsUpdateLoading: false,
  chemistryLogsUpdateData: null,
  chemistryLogsUpdateError: null,
};

const defaultGetTankState = {
  tankGetLoading: false,
  tankGetData: null,
  tankError: null,
};

const defaultGetTankDetailsByIdState = {
  tankDetailsLoading: false,
  tankDetailsData: null,
  tankDetailsError: null,
};

const fetchCreateFermentationData = createAsyncThunk(
  "fermentation/create",
  async (fermentationReq) => {
    return await FermentationServices.createFermentationApi(fermentationReq);
  },
);

const fetchGetFermentationData = createAsyncThunk(
  "fermentation/get",
  async (fermentationReq) => {
    return await FermentationServices.getFermentationApi(fermentationReq);
  },
);

const fetchFermentationDetailsById = createAsyncThunk(
  "fermentation/fermentationdetails",
  async (fermentationId) => {
    return await FermentationServices.getFermentationDetailsById(
      fermentationId,
    );
  },
);

const fetchUpdateFermentation = createAsyncThunk(
  "fermentation/update",
  async (fermentationReq) => {
    return await FermentationServices.updateFermentationApi(fermentationReq);
  },
);

const fetchCreateChemistryLogsData = createAsyncThunk(
  "chemistryLogs/create",
  async (chemistryLogsReq) => {
    return await FermentationServices.createChemistryLogs(chemistryLogsReq);
  },
);

const fetchGetChemistryLogsData = createAsyncThunk(
  "chemistryLogs/get",
  async (chemistryLogsReq) => {
    return await FermentationServices.getChemistryLogsList(chemistryLogsReq);
  },
);

const fetchUpdateChemistryLogsData = createAsyncThunk(
  "chemistryLogs/update",
  async (chemistryLogsReq) => {
    return await FermentationServices.updateChemistryLogs(chemistryLogsReq);
  },
);

const fetchGetTankListData = createAsyncThunk(
  "tank/get",
  async (tankLogsReq) => {
    return await FermentationServices.getTankList(tankLogsReq);
  },
);

const fermentationCreateReducer = createSlice({
  name: "createFermentation",
  initialState: defaultFermentationState,
  extraReducers: (builder) => {
    builder.addCase(fetchCreateFermentationData.pending, (state) => {
      state.fermentationLoading = true;
    });
    builder.addCase(fetchCreateFermentationData.fulfilled, (state, action) => {
      state.fermentationLoading = false;
      state.fermentationData = action.payload;
      state.fermentationError = "";
    });
    builder.addCase(fetchCreateFermentationData.rejected, (state, action) => {
      state.fermentationLoading = false;
      state.fermentationData = null;
      state.fermentationError = action.error.message;
    });
  },
});

const fermentationGetReducer = createSlice({
  name: "getFermentation",
  initialState: defaultGetFermentationState,
  extraReducers: (builder) => {
    builder.addCase(fetchGetFermentationData.pending, (state) => {
      state.fermentationGetLoading = true;
    });
    builder.addCase(fetchGetFermentationData.fulfilled, (state, action) => {
      state.fermentationGetLoading = false;
      state.fermentationGetData = action.payload;
      state.fermenError = "";
    });
    builder.addCase(fetchGetFermentationData.rejected, (state, action) => {
      state.fermentationGetLoading = false;
      state.fermentationGetData = null;
      state.fermentationError = action.error.message;
    });
  },
});

const fermentationDetailsByIdReducer = createSlice({
  name: "getFermentation",
  initialState: defaultGetFermentationDetailsByIdState,
  extraReducers: (builder) => {
    builder.addCase(fetchFermentationDetailsById.pending, (state) => {
      state.fermentationGetLoading = true;
    });
    builder.addCase(fetchFermentationDetailsById.fulfilled, (state, action) => {
      state.fermentationGetLoading = false;
      state.fermentationGetData = action.payload;
      state.fermentationGetError = "";
    });
    builder.addCase(fetchFermentationDetailsById.rejected, (state, action) => {
      state.fermentationGetLoading = false;
      state.fermentationGetData = null;
      state.fermentationGetError = action.error.message;
    });
  },
});

const fermentationUpdateReducer = createSlice({
  name: "updateFermentation",
  initialState: defaultUpdateFermentationState,
  extraReducers: (builder) => {
    builder.addCase(fetchUpdateFermentation.pending, (state) => {
      state.fermentationUpdateLoading = true;
    });
    builder.addCase(fetchUpdateFermentation.fulfilled, (state, action) => {
      state.fermentationUpdateLoading = false;
      state.fermentationUpdateData = action.payload;
      state.fermentationUpdateError = "";
    });
    builder.addCase(fetchUpdateFermentation.rejected, (state, action) => {
      state.fermentationUpdateLoading = false;
      state.fermentationUpdateData = null;
      state.fermentationUpdateError = action.error.message;
    });
  },
});

const chemistryLogsReducer = createSlice({
  name: "createChemistryLogs",
  initialState: defaultChemistryLogsState,
  extraReducers: (builder) => {
    builder.addCase(fetchCreateChemistryLogsData.pending, (state) => {
      state.chemistryLogsLoading = true;
    });
    builder.addCase(fetchCreateChemistryLogsData.fulfilled, (state, action) => {
      state.chemistryLogsLoading = false;
      state.chemistryLogsData = action.payload;
      state.chemistryLogsError = "";
    });
    builder.addCase(fetchCreateChemistryLogsData.rejected, (state, action) => {
      state.chemistryLogsLoading = false;
      state.chemistryLogsData = null;
      state.chemistryLogsError = action.error.message;
    });
  },
});

const chemistryLogsListReducer = createSlice({
  name: "getChemistryLogsList",
  initialState: defaultGetChemistryLogsState,
  extraReducers: (builder) => {
    builder.addCase(fetchGetChemistryLogsData.pending, (state) => {
      state.chemistryLogsGetLoading = true;
    });
    builder.addCase(fetchGetChemistryLogsData.fulfilled, (state, action) => {
      state.chemistryLogsGetLoading = false;
      state.chemistryLogsGetData = action.payload;
      state.chemistryLogsGetError = "";
    });
    builder.addCase(fetchGetChemistryLogsData.rejected, (state, action) => {
      state.chemistryLogsGetLoading = false;
      state.chemistryLogsGetData = null;
      state.chemistryLogsGetError = action.error.message;
    });
  },
});

const chemistryLogsUpdateReducer = createSlice({
  name: "updateChemistryLogs",
  initialState: defaultUpdateChemistryLogsState,
  extraReducers: (builder) => {
    builder.addCase(fetchUpdateChemistryLogsData.pending, (state) => {
      state.chemistryLogsUpdateLoading = true;
    });
    builder.addCase(fetchUpdateChemistryLogsData.fulfilled, (state, action) => {
      state.chemistryLogsUpdateLoading = false;
      state.chemistryLogsUpdateData = action.payload;
      state.chemistryLogsUpdateError = "";
    });
    builder.addCase(fetchUpdateChemistryLogsData.rejected, (state, action) => {
      state.chemistryLogsUpdateLoading = false;
      state.chemistryLogsUpdateData = null;
      state.chemistryLogsUpdateError = action.error.message;
    });
  },
});

const tankListReducer = createSlice({
  name: "getTankList",
  initialState: defaultGetTankState,
  extraReducers: (builder) => {
    builder.addCase(fetchGetTankListData.pending, (state) => {
      state.tankGetLoading = true;
    });
    builder.addCase(fetchGetTankListData.fulfilled, (state, action) => {
      state.tankGetLoading = false;
      state.tankGetData = action.payload;
      state.tankError = "";
    });
    builder.addCase(fetchGetTankListData.rejected, (state, action) => {
      state.tankGetLoading = false;
      state.tankGetData = null;
      state.tankError = action.error.message;
    });
  },
});

const fetchTankDetailsById = createAsyncThunk(
  "fermentation/tankdetails",
  async (itemId) => {
    return await FermentationServices.getTankDetailsById(itemId);
  },
);

const tankDetailsByIdReducer = createSlice({
  name: "tankDetailsById",
  initialState: defaultGetTankDetailsByIdState,
  extraReducers: (builder) => {
    builder.addCase(fetchTankDetailsById.pending, (state) => {
      state.tankDetailsLoading = true;
    });
    builder.addCase(fetchTankDetailsById.fulfilled, (state, action) => {
      state.tankDetailsLoading = false;
      state.tankDetailsData = action.payload;
      state.tankDetailsError = "";
    });
    builder.addCase(fetchTankDetailsById.rejected, (state, action) => {
      state.tankDetailsLoading = false;
      state.tankDetailsData = null;
      state.tankDetailsError = action.error.message;
    });
  },
});

export const FermentationGetReducer = fermentationGetReducer.reducer;
export const FermentationCreateReducer = fermentationCreateReducer.reducer;
export const FermentationDetailsByIdReducer =
  fermentationDetailsByIdReducer.reducer;
export const FermentationUpdateReducer = fermentationUpdateReducer.reducer;
export const ChemistryLogsReducer = chemistryLogsReducer.reducer;
export const ChemistryLogsListReducer = chemistryLogsListReducer.reducer;
export const ChemistryLogsUpdateReducer = chemistryLogsUpdateReducer.reducer;
export const TankListReducer = tankListReducer.reducer;
export const TankDetailsByIdReducer = tankDetailsByIdReducer.reducer;

export const FetchGetFermentationData = fetchGetFermentationData;
export const FetchCreateFermentationData = fetchCreateFermentationData;
export const FetchFermentationDetailsById = fetchFermentationDetailsById;
export const FetchUpdateFermentation = fetchUpdateFermentation;
export const FetchCreateChemistryLogsData = fetchCreateChemistryLogsData;
export const FetchGetChemistryLogsData = fetchGetChemistryLogsData;
export const FetchUpdateChemistryLogsData = fetchUpdateChemistryLogsData;
export const FetchGetTankListData = fetchGetTankListData;
export const FetchTankDetailsById = fetchTankDetailsById;
